import { render, staticRenderFns } from "./web20240828.vue?vue&type=template&id=b176f430&scoped=true&"
import script from "./web20240828.vue?vue&type=script&lang=js&"
export * from "./web20240828.vue?vue&type=script&lang=js&"
import style0 from "./web20240828.vue?vue&type=style&index=0&id=b176f430&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b176f430",
  null
  
)

export default component.exports